/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


document.addEventListener('DOMContentLoaded', () => {
    const steps = document.querySelectorAll('.step');
    const lines = document.querySelectorAll('.line img');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.animationPlayState = 'running';
                observer.unobserve(entry.target); // Para que la animación solo ocurra una vez
            }
        });
    }, { threshold: 0.1 });

    [...steps, ...lines].forEach(el => {
        el.style.animationPlayState = 'paused';
        observer.observe(el);
    });
});
